import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { MenuItem, Select, TextField } from "@mui/material";
import {
  getAllBulkTradeRequests,
  updateBulkTradeRequest,
  deleteBulkTradeRequest,
} from "../../../service/api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import { sanitizeInput } from "../../../config/validation";
import { triggerDownload } from "../../../config/downloadUtils";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import ReactSelect from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";

const formatDateTime = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const formatNumber = (val) =>
  val === undefined || val === null || val === ""
    ? "-"
    : Number(val).toLocaleString("en-IN", { maximumFractionDigits: 8 });

const formatMoney = (val) =>
  val === undefined || val === null || val === ""
    ? "-"
    : `₹ ${Number(val).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;

const userName = (r) => {
  const fn = r?.user?.firstName || "";
  const ln = r?.user?.lastName || "";
  const name = `${fn} ${ln}`.trim();
  return name || r?.user?.email || "-";
};

const sideBadge = (side) => {
  const color = side === "BUY" ? "#0E8345" : "#DB4437";
  return (
    <span
      style={{
        background: color,
        color: "#fff",
        padding: "2px 8px",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: 600,
      }}
    >
      {side || "-"}
    </span>
  );
};

const ALL_COLUMNS = [
  { key: "user", title: "User", defaultVisible: true, render: (r) => userName(r) },
  {
    key: "email",
    title: "Email",
    defaultVisible: true,
    render: (r) => r?.user?.email || "-",
  },
  {
    key: "phone",
    title: "Phone",
    defaultVisible: false,
    render: (r) => r?.user?.phoneNumber || "-",
  },
  {
    key: "_id",
    title: "User _id",
    defaultVisible: false,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.user?._id || "-"}</span>,
  },
  {
    key: "userId",
    title: "User ID",
    defaultVisible: false,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.user?.userId?.toUpperCase() || "-"}</span>,
  },
  { key: "side", title: "Side", defaultVisible: true, render: (r) => sideBadge(r?.side) },
  { key: "asset", title: "Asset", defaultVisible: true, render: (r) => r?.asset || "-" },
  {
    key: "quantity",
    title: "Quantity",
    defaultVisible: true,
    render: (r) => formatNumber(r?.quantity),
  },
  {
    key: "pricePerUnit",
    title: "Price / Unit",
    defaultVisible: true,
    render: (r) => formatMoney(r?.pricePerUnit),
  },
  {
    key: "estimatedTotal",
    title: "Est. Total",
    defaultVisible: true,
    render: (r) => formatMoney(r?.estimatedTotal),
  },
  {
    key: "tds",
    title: "TDS",
    defaultVisible: true,
    render: (r) => formatMoney(r?.tds),
  },
  {
    key: "txnFee",
    title: "Txn Fee",
    defaultVisible: true,
    render: (r) => formatMoney(r?.txnFee),
  },
  {
    key: "igst",
    title: "IGST",
    defaultVisible: true,
    render: (r) => formatMoney(r?.igst),
  },
  {
    key: "netAmount",
    title: "Net Amount",
    defaultVisible: true,
    render: (r) => formatMoney(r?.netAmount),
  },
  // {
  //   key: "userRequestCount",
  //   title: "User Requests",
  //   defaultVisible: true,
  //   render: (r) => r?.userRequestCount ?? "-",
  // },
  {
    key: "status",
    title: "Status",
    defaultVisible: true,
    render: (r) => r?.status || "-",
  },
  {
    key: "emailSent",
    title: "Email Sent",
    defaultVisible: false,
    render: (r) => (r?.emailSent ? "Yes" : "No"),
  },
  {
    key: "createdAt",
    title: "Created",
    defaultVisible: true,
    render: (r) => formatDateTime(r?.createdAt),
  },
  {
    key: "updatedAt",
    title: "Updated",
    defaultVisible: false,
    render: (r) => formatDateTime(r?.updatedAt),
  },
];

const statusOptions = [
  { label: "Pending", value: "PENDING" },
  { label: "Contacted", value: "CONTACTED" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Cancelled", value: "CANCELLED" },
];

const sideOptions = [
  { label: "Buy", value: "BUY" },
  { label: "Sell", value: "SELL" },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "100%",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
  indicatorSeparator: () => ({ display: "none" }),
};

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const BulkTradeRequests = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState();
  const [sideFilter, setSideFilter] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  // Edit (status / note) panel state
  const [edit, setEdit] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const [editInput, setEditInput] = useState({ status: "", adminNote: "" });
  const [editError, setEditError] = useState({ status: false });

  // Delete modal state
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [deleteRow, setDeleteRow] = useState(null);

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "bulk-trade-request-list",
    allColumns: ALL_COLUMNS,
  });

  const buildFilters = (overrides = {}) => {
    const body = { ...overrides };
    if (searchTerm) body.search = searchTerm;
    if (statusFilter?.value) body.status = statusFilter.value;
    if (sideFilter?.value) body.side = sideFilter.value;
    if (startDate) body.startDate = startDate;
    if (endDate) body.endDate = endDate;
    return body;
  };

  const getList = () => {
    const body = buildFilters({ page, sizePerPage: pageSize, pagination: true });
    setLoading(true);
    getAllBulkTradeRequests(body)
      .then((res) => {
        if (res?.status) {
          setList(res?.data);
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = buildFilters({ pagination: false });
    setDownloadLoading(true);
    getAllBulkTradeRequests(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) {
          toast.warning("Nothing to download", { toastId: 'nothing-to-download' });
          return;
        }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "bulk-trade-requests");
      })
      .finally(() => setDownloadLoading(false));
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, searchTerm, statusFilter, sideFilter, startDate, endDate]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, searchTerm, statusFilter, sideFilter, startDate, endDate]);

  const handleDateRangeChange = (event, picker) => {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  const openEdit = (row) => {
    setActiveRow(row);
    setEditInput({ status: row?.status || "PENDING", adminNote: row?.adminNote || "" });
    setEditError({ status: false });
    setEdit(true);
  };

  const submitEdit = () => {
    if (!editInput?.status) {
      setEditError({ status: true });
      return;
    }
    setLoading(true);
    updateBulkTradeRequest(activeRow?._id, {
      status: editInput.status,
      adminNote: editInput.adminNote,
    })
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message, { toastId: 'bulk-trade-approve-success' });
          setEdit(false);
          setActiveRow(null);
          getList();
        } else {
          toast.error(res?.message, { toastId: 'bulk-trade-approve-error' });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message, { toastId: 'bulk-trade-approve-error' });
      })
      .finally(() => setLoading(false));
  };

  const handleDeleteFunction = () => {
    setLoading(true);
    deleteBulkTradeRequest(deleteRow?._id)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message, { toastId: 'bulk-trade-reject-success' });
          handleCloseDelete();
          getList();
          setDeleteRow(null);
        } else {
          toast.error(res?.message, { toastId: 'bulk-trade-reject-error' });
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message, { toastId: 'bulk-trade-reject-error' });
      })
      .finally(() => setLoading(false));
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        <a
          className="me-1 btn btn-sm bg-success-light"
          onClick={() => openEdit(row)}
        >
          <i className="fe fe-pencil"></i> Edit
        </a>
        <a
          onClick={() => {
            handleOpenDelete();
            setDeleteRow(row);
          }}
          className="me-1 btn btn-sm bg-danger-light"
        >
          <i className="fe fe-trash"></i> Delete
        </a>
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Bulk Trade Requests</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Bulk Trade Requests</li>
                </ul>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              {edit ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0px",
                      gap: "10px",
                    }}
                  >
                    <div style={{ display: "flex", gap: "10px" }}>
                      <FaArrowLeft
                        style={{
                          marginTop: "3px",
                          cursor: "pointer",
                          width: "30px",
                          height: "20px",
                        }}
                        onClick={() => {
                          setEdit(false);
                          setActiveRow(null);
                        }}
                      />
                      <h4>Update Request</h4>
                    </div>
                    <div
                      style={{
                        height: "56px",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={submitEdit}
                        disabled={loading}
                        style={{ marginBottom: "10px", marginTop: "9px" }}
                      >
                        {loading ? <Spinner size="sm" /> : "Update"}
                      </button>
                    </div>
                  </div>

                  {/* Read-only summary of the request being updated */}
                  <div
                    style={{
                      margin: "10px",
                      padding: "12px",
                      background: "#f7f7f7",
                      borderRadius: "8px",
                    }}
                  >
                    <strong>{userName(activeRow)}</strong> &nbsp;·&nbsp;{" "}
                    {activeRow?.side} {formatNumber(activeRow?.quantity)}{" "}
                    {activeRow?.asset} @ {formatMoney(activeRow?.pricePerUnit)}{" "}
                    &nbsp;·&nbsp; Est. {formatMoney(activeRow?.estimatedTotal)}
                  </div>

                  <div style={{ margin: "10px" }} className="page-grid">
                    <div style={{ margin: "10px", textAlign: "left" }}>
                      <InputLabel style={{ marginLeft: "7px" }}>
                        Status &nbsp;
                        {editError?.status && (
                          <small style={{ color: "red" }}>
                            {"Status is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        className="form-control select-sorting"
                        value={editInput?.status}
                        onChange={(e) => {
                          setEditInput({ ...editInput, status: e.target.value });
                          setEditError({ status: false });
                        }}
                        style={{
                          border: "none",
                          padding: 0,
                          width: "100%",
                          height: "56px",
                        }}
                      >
                        {statusOptions.map((opt) => (
                          <MenuItem
                            key={opt.value}
                            style={{ height: "40px" }}
                            value={opt.value}
                          >
                            {opt.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>

                    <div style={{ margin: "10px" }}>
                      <InputLabel style={{ marginLeft: "7px" }}>
                        Admin note
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{ marginLeft: "5px", height: "100%" }}
                        className="form-control"
                        type="text"
                        placeholder="Internal note (optional)"
                        value={editInput?.adminNote}
                        onChange={(e) =>
                          setEditInput({
                            ...editInput,
                            adminNote: sanitizeInput(e.target.value),
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="list-layout">
                  <div className="list-layout__main">
                    <div className="card">
                      <div className="card-body">
                        <TableToolbar
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pageSizeOptions={pageSizeOptions}
                          total={list?.total}
                          page={page}
                          visibleColumnKeys={visibleColumnKeys}
                          allColumns={ALL_COLUMNS}
                          toggleColumn={toggleColumn}
                          resetColumns={resetColumns}
                          onDownload={handleDownload}
                          downloadLoading={downloadLoading}
                        />
                        <div className="table-responsive">
                          {loading ? (
                            <div className="his-spin">
                              <Spin
                                size="large"
                                style={{ position: "relative", top: "35%" }}
                              />
                            </div>
                          ) : (
                            <Table
                              pagination={false}
                              style={{ overflowX: "auto" }}
                              columns={columns2}
                              dataSource={list ? list?.result : []}
                              rowKey={(record) => record._id || record.id}
                            />
                          )}
                          {list && list?.total > pageSize && (
                            <CustomPagination
                              key={`pg-${pageSize}`}
                              totalTabs={list?.total}
                              tabsPerPage={pageSize}
                              handleChange={setPage}
                              className={`${
                                loading ? "display-hide" : "display-flex"
                              }`}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="list-layout__filters">
                    <FilterPanel
                      count={list?.total}
                      onClear={() => {
                        setSearchTerm("");
                        setStatusFilter(null);
                        setSideFilter(null);
                        setStartDate();
                        setEndDate();
                      }}
                    >
                      <FilterPanel.Field label="Search">
                        <input
                          type="text"
                          placeholder="Name, email, phone or asset"
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerm(sanitizeInput(e.target.value))
                          }
                        />
                      </FilterPanel.Field>
                      <FilterPanel.Field label="Side">
                        <ReactSelect
                          options={sideOptions}
                          value={sideFilter || null}
                          onChange={(opt) => setSideFilter(opt)}
                          styles={customStyles}
                          placeholder="Any"
                          isClearable
                        />
                      </FilterPanel.Field>
                      <FilterPanel.Field label="Status">
                        <ReactSelect
                          options={statusOptions}
                          value={statusFilter || null}
                          onChange={(opt) => setStatusFilter(opt)}
                          styles={customStyles}
                          placeholder="Any"
                          isClearable
                        />
                      </FilterPanel.Field>
                      <FilterPanel.Field label="Date Range">
                        <DateRangePicker
                          onApply={handleDateRangeChange}
                          isClearable={true}
                        >
                          <input
                            type="text"
                            placeholder="Select date range"
                            readOnly
                          />
                        </DateRangePicker>
                      </FilterPanel.Field>
                    </FilterPanel>
                  </div>
                </div>
              )}
            </div>
          </div>

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{ backdrop: { timeout: 500 } }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default BulkTradeRequests;
